<template>
<div class="p-8 login-tabs-container">

  <h4 class="mb-8">{{ $t('message.register.newClientHeader') }}</h4>

  <div class="vx-card__title mb-4">
    <label class="w-full flex justify-between">
      <div class="w-1/3 text-right leading-form pr-2 hidden md:block">{{ $t('message.register.newClientNameLabel') }}</div>
      <vs-input
        name="name" @input="$emit('update:name', $event)"
        :placeholder="$t('message.register.newClientName')"
        :value="name"
        class="w-full md:w-2/3"/>
    </label>
  </div>
  <div class="vx-card__title mb-4">
    <label class="w-full flex justify-between">
      <div class="w-1/3 text-right leading-form pr-2 hidden md:block">{{ $t('message.register.newClientOGRNLabel') }}</div>
      <vs-input
        name="ogrn" @input="$emit('update:ogrn', $event)"
        :placeholder="$t('message.register.newClientOGRN')"
        :value="ogrn"
        class="w-full md:w-1/3"/>
      <label class="w-1/3 leading-form text-center px-2 cursor-pointer underline text-primary">
        {{ $t('message.register.newClientDownload') }}
        <input type="file" class="hidden" @change="fileChanged('update:fileOgrn', $event)">
      </label>
    </label>
  </div>
  <div class="vx-card__title mb-4">
    <label class="w-full flex justify-between">
      <div class="w-1/3 text-right leading-form pr-2">{{ $t('message.register.newClientReestr') }}</div>
      <label class="w-2/3 leading-form text-left cursor-pointer underline text-primary">
        {{ $t('message.register.newClientDownload') }}
        <input type="file" class="hidden" @change="fileChanged('update:fileRegister', $event)">
      </label>
    </label>
  </div>
  <div class="vx-card__title mb-4">
    <label class="w-full flex justify-between">
      <div class="w-1/3 text-right leading-form pr-2 hidden md:block">{{ $t('message.register.newClientTin') }}</div>
      <vs-input
        name="tin" @input="$emit('update:tin', $event)"
        :placeholder="$t('message.register.newClientTin')"
        :value="tin"
        class="w-full md:w-1/3"/>
      <label class="w-1/3 leading-form text-center px-2 cursor-pointer underline text-primary">
        {{ $t('message.register.newClientDownload') }}
        <input type="file" class="hidden" @change="fileChanged('update:fileTin', $event)">
      </label>
    </label>
  </div>
  <div class="vx-card__title mb-4">
    <label class="w-full flex justify-between">
      <div class="w-1/3 text-right leading-form pr-2 hidden md:block">{{ $t('message.register.newClientAddressLabel') }}</div>
      <vs-input
        name="address" @input="$emit('update:address', $event)"
        :placeholder="$t('message.register.newClientAddress')"
        :value="address"
        class="w-full md:w-2/3"/>
    </label>
  </div>
  <div class="vx-card__title mb-4">
    <label class="w-full flex justify-between">
      <div class="w-1/3 text-right leading-form pr-2 hidden md:block">{{ $t('message.register.newClientContact') }}</div>
      <vs-input
        name="contact" @input="$emit('update:contact', $event)"
        :placeholder="$t('message.register.newClientContact')"
        :value="contact"
        class="w-full md:w-2/3"/>
    </label>
  </div>

  <div class="vx-card__title mb-4 mt-24 text-center">
    <vs-button @click="$emit('next-step')" line-origin="center"
               color="primary" type="gradient" class="mt-8">
      {{ $t('message.register.sendRequestButton') }}
    </vs-button>
  </div>

</div>
</template>

<script>
export default {
  name: 'RegistrationQuiz',
  props: {
    fileOgrn: {},
    fileRegister: {},
    fileTin: {},
    phone: {},
    name: {},
    ogrn: {},
    reestr: {},
    tin: {},
    address: {},
    contact: {}
  },
  data: () => ({
    agrement: false
  }),
  methods: {
    fileChanged (eventName, event) {
      this.$emit(eventName, event.target.files)
    }
  }
}
</script>

<style scoped>

</style>
